import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import * as R from 'ramda'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { compose } from 'redux'
import { toggleDropBox, addComment } from '../../actions'
import ContentEditable from 'react-contenteditable'
import {FETCH_TAGS_SUCCESS, TOGGLE_COMMENTS_SUCCESS} from '../../actionTypes'
import Comment  from '../../components/Comment'
import { snapshotToArray } from '../../selectors'
import database from "../../actions/database";
import { getLinkFromText } from '../../functions/snippets'
import Autolinker from 'autolinker'
import Icon from '@material-ui/core/Icon';



class Comments extends Component {

    constructor(props){
        super(props);

        this.state = {
            text: '',
            users: {}
        }
        this.handleAddComment = this.handleAddComment.bind(this)
    }

    componentDidMount(){
        const { id } = this.props.ownProps.params
        database.ref('/data/' + id + '/users/').once('value', snap => {
           const payload = snap.val()
            this.setState({
                users: payload
            })

        })
            .catch((error) => {
                console.log(error);
            });

        const rootRef = database.ref().child('/data/'+id+'/users')
        rootRef.on('value', snapshot => {
            const payload = snapshot.val();
            this.setState({
                users: payload
            })

        });

    }

    componentWillReceiveProps(nextProps) {
        setTimeout(()=>{
            this.handleScroll ()
        })

        const id = nextProps.ownProps.params.id;


        if (id !== this.props.ownProps.params.id) {

            //const { id } = this.props.ownProps.params
            database.ref('/data/' + id + '/users/').once('value', snap => {
                const payload = snap.val()
                this.setState({
                    users: payload
                })

            })
                .catch((error) => {
                    console.log(error);
                });

            const rootRef = database.ref().child('/data/'+id+'/users')
            rootRef.on('value', snapshot => {
                const payload = snapshot.val();
                this.setState({
                    users: payload
                })

            });


        }


    }


    handleScroll (){
        this.content.scrollIntoView({block: "end"});

    }



    handleAddComment(line, listKey, user) {
        const comment = {
            text: this.state.text,
            date: Date.now(),
            keyLine: line.id,
            userId: user.id
        }
        if(!this.state.text) return

        this.props.addComment(listKey, comment, user)
        this.setState({
            text: ''
        })

        this.handleScroll()
    }

    render() {
        const { dropBox, toggleDropBox, line, comments, user } = this.props
        const listKey = this.props.ownProps.params.id
        const dropClass = classNames({
            'comment': true,
            'active': dropBox.comments
        });


       const  handleChange = (event) => {


            let text = event.target.value
            this.setState({
                text: text.replace(/<([^\s]+?)(\s+?[^\s]+?)*>/gi, '<$1>')
            })


        }




        const AddComment = () => {

            this.handleAddComment(line, listKey, user)
        }

        const submitTrigger = event => {
            var charCode = (event.which) ? event.which : event.keyCode
            const input = ReactDOM.findDOMNode(this.input);

            // Enter key
            if(charCode == 13 && !event.shiftKey) {
                event.preventDefault();
                input.click()
                return false;
            }

            /*if (event.keyCode == 13 && event.shiftKey) {

                event.stopPropagation();
            }else if(event.keyCode == 13)
            {
                event.stopPropagation();
                event.preventDefault();
                //this.handleAddComment(line, listKey, user)

                //AddComment()
            }*/
        }

        const closeDropComments = () => {
            toggleDropBox(TOGGLE_COMMENTS_SUCCESS)

        }

        const shortTitle = `${R.take(50, line.text ? line.text : '')}...`
        var autolinker = new Autolinker( {
            urls : {
                schemeMatches : true,
                wwwMatches    : true,
                tldMatches    : true
            },
            email       : true,
            phone       : true,
            mention     : 'instagram',
            hashtag     : false,

            stripPrefix : false,
            stripTrailingSlash : true,
            newWindow   : true,

            truncate : {
                length   : 40,
                location : 'end'
            },

            className : 'link'
        } );

        return (
            <div className={dropClass}>
                <div className="comment__wrap">
                    <div className="comment__header">
                        <div className="comment__index">{ line.index + 1 }.</div>
                        <div className="comment__title" dangerouslySetInnerHTML={{__html: shortTitle}}>
                        </div>

                        <div className="comment__close" onClick={closeDropComments}>
                            <Icon>arrow_right_alt</Icon>
                        </div>
                    </div>

                    <div className="comment__content" >
                        <div ref={input => this.content = input}>
                            {
                                comments && comments.map((comment, key) => {
                                    let userComment = this.state.users[comment.userId ? comment.userId : comment.user.id]
                                    return <Comment  userObj={user} key={key} {...comment} text={ autolinker.link(comment.text) } user={userComment}/>
                                })
                            }
                        </div>
                    </div>

                    <div className="comment__bottom">
                        <div className="comment-add">
                                <div className="comment-add__field-wrap">
                                    <ContentEditable
                                        onChange={ e => handleChange(e) }
                                        onKeyPress={ e => submitTrigger(e) }
                                        className="comment-add__field"
                                        html={this.state.text}
                                    />
                                </div>
                                <div className="comment-add__btn-wrap">
                                    <button ref={input => this.input = input} onClick={ AddComment } className="comment-add__btn" type="submit">
                                        <i className="nav__icon icon-share"></i>
                                    </button>
                                </div>
                        </div>
                    </div>
                </div>

             </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    dropBox: state.dropBox,
    line: state.openComments.line,
    comments: snapshotToArray(state.openComments.comments),
    user: state.user,
    ownProps
})

const mapDispatchToProps = {
    toggleDropBox,
    addComment
}

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(Comments)


// WEBPACK FOOTER //
// ./src/containers/drop/Comments.js